import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { rgba } from 'polished';
import React from 'react';

import { Flex, Icon } from '~/components/blocks';

const Root = styled(Flex)(() =>
  css({
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  }),
);

const DisabledReason = styled('div')(({ theme }) =>
  css({
    backgroundColor: rgba(theme.colors.background.black, 0.85),
    borderRadius: theme.radii.default,
    color: theme.colors.text.white,
    fontSize: theme.fontSizes.s,
    fontWeight: theme.fontWeights.bold,
    padding: `${theme.space.m} ${theme.space.l}`,
    position: 'absolute',
    textAlign: 'center',
    zIndex: 1,
    bottom: `-${theme.space.l}`,
  }),
);

export const PermissionError = () => {
  return (
    <Root>
      <DisabledReason>
        <Icon size="l" icon="attention" />
        店舗管理の権限がありません
      </DisabledReason>
    </Root>
  );
};

PermissionError.displayName = 'PermissionError';
